"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCountryFlag = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Box = _interopRequireDefault(require("../Box"));
var _constant = require("../../styles/constant");
var _templateObject;
const flagSizeConfig = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    large: {
      width: (0, _constant.get)('space.30')
    },
    small: {
      width: (0, _constant.get)('space.20')
    },
    medium: {
      width: (0, _constant.get)('space.26')
    }
  }
});
const variants = {
  flagSizeConfig
};
const StyledCountryFlag = exports.StyledCountryFlag = (0, _styledComponents["default"])(_Box["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), variants.flagSizeConfig);